<mg-table [collectionComponent]="this" matSort stickyHeaders>

	<ng-container matColumnDef="rubriekID">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Rubriek </th>
        <td mat-cell *matCellDef="let row"> {{row.rubriekID?.titel}} </td>
    </ng-container>

	<ng-container matColumnDef="korting">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Korting </th>
        <td mat-cell *matCellDef="let row"> {{row.korting}} </td>
    </ng-container>

</mg-table>
